import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonSlider from '../../../../../components/common-slider/CommonSlider';
import { DEFAULT_FILTERS } from '../../../../config';
import { useMediaStudio } from '../../../../context/MediaStudioContext';
import { FILTER_SLIDERS } from '../../constants';
import InspectorSection from '../inspector-section/InspectorSection';

function FiltersSection({ element }) {
  const { t } = useTranslation('mediaStudio');
  const { editor } = useMediaStudio();
  const filters = { ...DEFAULT_FILTERS, ...element.filters };

  return (
    <InspectorSection title={t('filters')}>
      {FILTER_SLIDERS.map((slider) => (
        <CommonSlider
          key={slider.key}
          label={t(slider.labelKey)}
          icon={slider.icon}
          min={slider.min}
          max={slider.max}
          value={filters[slider.key]}
          resetValue={0}
          resetLabel={t('resetSlider')}
          throttleMs={220}
          onChange={(value) => editor.change(element.id, { filters: { [slider.key]: value } }, { live: true })}
          onCommit={editor.endGesture}
        />
      ))}
    </InspectorSection>
  );
}

export default FiltersSection;
